import React from "react";
import { Stack, Box } from "@mui/material";
import InputText from "../InputFields/InputText";
import "./style.css";
import "../AddPayment/style.css";
function RequiredStar() {
  return (
    <span className="cs-field-label-required" aria-hidden="true">
      {" "}
      *
    </span>
  );
}

function AchInfo({ formik, disabled, useCollectJsInline }) {
  const achHostErrorSx = (show) =>
    show
      ? {
          border: "1px solid #dc3545 !important",
          borderColor: "#dc3545 !important",
        }
      : undefined;

  const requiredStar = (
    <span className="cs-field-label-required" aria-hidden="true">
      {" "}
      *
    </span>
  );

  const labelInputGap = "10px";

  return (
    <Stack spacing={2} sx={{ mt: 0, pt: 0, width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box" }}>
      <Box sx={{ width: "100%" }}>
          {useCollectJsInline ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: labelInputGap,
                }}
              >
                <label className="cs-rs__label">
                  Account Holder Name
                  <RequiredStar />
                </label>
                <Box
                  id="checkname"
                  className="payment-field ach-collect-inline-host"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    ...(achHostErrorSx(
                      formik?.touched?.checkname && Boolean(formik?.errors?.checkname)
                    ) || {}),
                  }}
                />
              </Box>
            </>
          ) : (
            <InputText
              value={formik?.values?.checkname}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              error={
                formik?.touched?.checkname && Boolean(formik?.errors?.checkname)
              }
              showErrorOnly
              name="checkname"
              label="Account Holder Name"
              required
              type="text"
              disable={disabled}
              className="text-blue-color w-100 accountInformationInputTop"
              fieldHeight="44px"
            />
          )}
        </Box>

      <Box
        sx={{
          display: "grid",
          width: "100%",
          maxWidth: "100%",
          gridTemplateColumns: {
            xs: "minmax(0, 1fr)",
            sm: "minmax(0, 1fr) minmax(0, 1fr)",
          },
          gap: 2,
          alignItems: "stretch",
        }}
      >
        <Box
          sx={{
            minWidth: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {useCollectJsInline ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: labelInputGap,
                }}
              >
                <label className="cs-rs__label">
                  Routing Number
                  {requiredStar}
                </label>
                <Box
                  id="checkaba"
                  className="payment-field ach-collect-inline-host"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    ...achHostErrorSx(
                      formik?.touched?.checkaba && Boolean(formik?.errors?.checkaba)
                    ),
                  }}
                />
              </Box>
            </>
          ) : (
            <InputText
              value={formik?.values?.checkaba}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              error={
                formik?.touched?.checkaba && Boolean(formik?.errors?.checkaba)
              }
              showErrorOnly
              name="checkaba"
              label="Routing Number"
              required
              type="text"
              disable={disabled}
              className="text-blue-color w-100 accountInformationInputTop"
              fieldHeight="44px"
            />
          )}
        </Box>
        <Box
          sx={{
            minWidth: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {useCollectJsInline ? (
            <>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: labelInputGap,
                }}
              >
                <label className="cs-rs__label">
                  Account Number
                  <RequiredStar />
                </label>
                <Box
                  id="checkaccount"
                  className="payment-field ach-collect-inline-host"
                  sx={{
                    width: "100%",
                    minWidth: 0,
                    ...achHostErrorSx(
                      formik?.touched?.checkaccount &&
                        Boolean(formik?.errors?.checkaccount)
                    ),
                  }}
                />
              </Box>
            </>
          ) : (
            <InputText
              value={formik?.values?.checkaccount}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              error={
                formik?.touched?.checkaccount &&
                Boolean(formik?.errors?.checkaccount)
              }
              showErrorOnly
              name="checkaccount"
              label="Account Number"
              required
              type="text"
              disable={disabled}
              className="text-blue-color w-100 accountInformationInputTop"
              fieldHeight="44px"
            />
          )}
        </Box>
      </Box>
    </Stack>
  );
}

export default AchInfo;
